import {TextInput, TextInputHidden, SquareButton, ForwardsBackwardsBar, HeaderBig, LoadButton} from '../common/Common';
import {useContext, useEffect, useState} from 'react';
import './ForgotPassword.css';
import { LocaleContext, LoginContext, StateContext } from '../common/App';
import { checkEmail, postWithCsrf } from '../common/util';
import { LoadState } from '../common/enums';
import { maxUsernameLength } from '../common/globals_common';
import { useNavigateSmart } from '../common/hooks';

export function ForgotPassword(props) {
    const locale = useContext(LocaleContext);
    const state = useContext(StateContext);
    const login = useContext(LoginContext);

    const navigate = useNavigateSmart();

    const [email, setEmail] = useState("");

    const [sendState, setSendState] = useState(LoadState.NONE);

    function resetPassword() {
        try {
            postWithCsrf("/user/send_password_reset_mail", JSON.stringify({email: email}), state).then(response => {
                if(response.ok) {
                    // setResendText(locale.msgs.RESEND_MAIL_SUCCESS);
                    // setResendTextClass("text_success");
                    setSendState(LoadState.LOAD_SUCCESS);
                    return;
                }
                
                throw new Error("Response code: " + response.status);
            }).catch(error => {
                console.log("ERROR: " + error);
                // setResendText(locale.msgs.RESEND_MAIL_ERROR);
                // setResendTextClass("text_error");
                setSendState(LoadState.LOAD_ERROR);
            });
            
            // Calling setSendState() after postWithCsrf() as it could throw an exception
            setSendState(LoadState.LOADING);
        }
        catch(e) {
            console.log(e);
        }
    }

    function isClickable() {
        if(!email || email === "") {
            return false;
        }

        return true;
    }


    useEffect(() => {
        // const eventSource = new EventSource("/user/is_mail_confirmed_sse");
  // 
        // eventSource.onmessage = function(event) {
        //     // const data = JSON.parse(event.data);
        //     // console.log("Got message: " + data.message);
        //     
        //     navigate("/mail_confirmed?username=" + login.username);
        // };
// 
        // eventSource.onerror = function(error) {
        //     console.error("EventSource failed:", error);
        //     eventSource.close();
        // };
    }, []);

    return (
        <div className="forgot_password_box">
            
                { sendState !== LoadState.LOAD_SUCCESS ?
                    <div className="forgot_password_content side_padding">
                
                        <div className="head">{locale.msgs.FORGOT_PASSWORD}</div>
                        <div className="text">{locale.msgs.FORGOT_PASSWORD_DECSR}</div>

                        <div className="forgot_password_email_input">
                            <TextInput text={locale.msgs.EMAIL} name="email" type="email" autocomplete="email" value={email}
                                    onChange={(value) => setEmail(value)}
                                    checker={(v) => checkEmail(v)}
                                    errorText={locale.msgs.ENTER_VALID_EMAIL_ADDRESS}
                                    maxLength={maxUsernameLength} />
                        </div>

                        <div className="forgot_password_btn_box">
                            <div>
                                <SquareButton white={true} text={locale.msgs.BACK} clickable={true} onClick={() => navigate("/login")} />
                            </div>

                            <div>
                                <LoadButton text={locale.msgs.RESET} clickable={isClickable()}
                                        onClick={() => resetPassword()}
                                        saving={sendState === LoadState.LOADING}
                                        notSaved={sendState === LoadState.LOAD_ERROR}
                                        errText={locale.msgs.ERROR} />
                            </div>
                        </div>
                    </div>
                :
                    <div className="forgot_password_content side_padding">
                        <div className="head">{locale.msgs.PWD_RESET_MAIL_WAS_SENT}</div>
                        <div className="text">{locale.msgs.PWD_RESET_MAIL_WAS_SENT_DESCR}</div>

                        <div className="forgot_password_btn_box">
                            <div>
                                <SquareButton white={true} text={locale.msgs.BACK} clickable={true} onClick={() => setSendState(LoadState.NONE)} />
                            </div>
                        </div>
                    </div>
                }
        </div>
    );
}
